import { render, staticRenderFns } from "./StartUpCost.vue?vue&type=template&id=b2181a08&scoped=true&"
import script from "./StartUpCost.vue?vue&type=script&lang=js&"
export * from "./StartUpCost.vue?vue&type=script&lang=js&"
import style0 from "./StartUpCost.vue?vue&type=style&index=0&id=b2181a08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2181a08",
  null
  
)

export default component.exports